import React from "react";
import AboutOne from "../../components/About/AboutOne"; // Adjust the import path as needed
import CounterOne from "../../components/About/CounterOne";
import videoImg from "../../assets/images/aboutus/ceodesk.png";
import WhyAreWe from "../../components/About/WhyAreWe";
import image1 from "../../assets/images/resources/why-are-we-img-1.jpg";
import image2 from "../../assets/images/resources/why-are-we-img-2.jpg";
import TestimonialsSection from "../../components/About/TestimonialsSection";
import ServicesCarouselMain from "../services-carousel/ServicesCarouselMain";
const AboutMain = () => {
  const counters = [
    {
      iconClass: "icon-schedule",
      end: 100,
      suffix: "+",
      text: "Our Happy Customers",
    },
    {
      iconClass: "icon-schedule",
      end: 2,
      suffix: "k",
      plus: true,
      text: "Our Team Members",
    },
    {
      iconClass: "icon-schedule",
      end: 3,
      suffix: "k",
      plus: true,
      text: "Our Client Reviews",
    },
  ];
  // const points = [
  //   {
  //     iconClass: "why-are-we__icon",
  //     arrowIcon: "icon-arrow-down-left",
  //     icon: "icon-location why-are-we__location",
  //     heading: "Real Time tracking",
  //     text: "Logistic service involves the implementation and control",
  //   },
  //   {
  //     iconClass: "why-are-we__icon-2",
  //     arrowIcon: "icon-arrow-down-right",
  //     icon: "icon-shopping-cart why-are-we__cart",
  //     heading: "On time delivery",
  //     text: "Logistic service involves the implementation and control",
  //   },
  //   {
  //     iconClass: "",
  //     arrowIcon: "",
  //     icon: "icon-call why-are-we__call",
  //     heading: "24/7 online support",
  //     text: "Logistic service involves the implementation and control",
  //   },
  // ];

  const points = [
    {
      iconClass: "why-are-we__icon",
      arrowIcon: "icon-arrow-down-left",
      icon: "icon-location why-are-we__location",
      heading: "24/7 Support",
      text: "Prompt, all-weather service anytime you need.",
    },
    {
      iconClass: "why-are-we__icon-2",
      arrowIcon: "icon-arrow-down-right",
      icon: "icon-shopping-cart why-are-we__cart",
      heading: "Expert Maintenance",
      text: "Trained teams with strict quality control systems.",
    },
    {
      iconClass: "",
      arrowIcon: "",
      icon: "icon-call why-are-we__call",
      heading: "Project-Focused Care",
      text: "Dedicated staff for regular checks on large sites.",
    },
  ];
  return (
    <React.Fragment>
      {/* <AboutOne /> */}
      <CounterOne
        imageSrc={videoImg}
        videoId="" // YouTube video ID
        videoCaption="Watch our video"
        tagline=""
        title="Visionary Leadership Behind Arch Elevators' Success"
        description="At Arch Elevators Pvt. Ltd., our vision for excellence is driven by Mr. Animesh Desai, Managing Director & CEO, with a Bachelor of Engineering degree and over 30 years of industry expertise. Under his leadership, Arch Elevators has become one of India’s leading elevator companies, trusted in heavy industry projects, government contracts, and metro rail installations.
<br><br>
We take pride in being India’s only manufacturer of Circular Elevators, reflecting our spirit of innovation and commitment to quality. Guided by Mr. Desai’s strategic vision, we focus on timely delivery, sustainable practices, and advanced technologies, setting new benchmarks in vertical mobility.
<br><br>
Our customer-first approach ensures every project is handled with precision, reliability, and transparency. With a strong nationwide presence and growing global footprint, we continue to expand horizons and build lasting trust.
<br>
At Arch Elevators, we don’t just build elevators, we elevate experiences."
//         description="At the heart of Arch Elevators Pvt. Ltd. stands a vision for excellence, led by our Managing Director and CEO, Mr. Animesh Desai — a distinguished leader with a Bachelor of Engineering degree and over three decades of industry expertise. <br /><br />
//         Under Mr. Desai’s stewardship, Arch Elevators has risen to become one of India's leading elevator companies, trusted across heavy industry projects, government contracts, and major infrastructure developments, including metro rail installations. His strategic acumen has driven remarkable growth and profitability, positioning Arch Elevators at the forefront of vertical transportation solutions. <br /><br />
// Our legacy includes being recognized as India's sole manufacturer of Circular Elevators, a testament to our pioneering spirit and relentless commitment to innovation. Mr. Desai’s leadership fosters a culture of excellence, customer satisfaction, and technological advancement, setting new standards across the industry. <br /><br />
// With a sharp focus on timely project delivery and sustainable practices, Arch Elevators continues to evolve, leveraging emerging technologies to enhance our offerings. Guided by a passion for innovation and a commitment to quality, we are shaping the future of vertical mobility — not just within India, but on a global scale. <br /><br />
// At Arch Elevators, we don’t just build elevators — we elevate experiences."
        counters={counters}
      />
      <TestimonialsSection />
      <WhyAreWe
        imageSrc1={image1}
        imageSrc2={image2}
        tagline="Why Choose Arch Elevators?"
        title="Excellence in Every Rise. Trust in Every Floor."
        points={points}
        year="Since 1991"
        yearDescription="Delivering smart vertical mobility through precision planning, seamless execution, and expert maintenance — redefining efficiency in every rise."
      />
      <ServicesCarouselMain compact />
    </React.Fragment>
  );
};

export default AboutMain;
